import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ClientInformationBlockData from '../../../Models/Content/ClientInformationBlockData';
import ClientInformationMain from './ClientInformationMain';

export default class ClientInformationBlock extends EpiComponent<ClientInformationBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <ClientInformationMain iContent={this.props.data} context={this.getContext()} />;
  }
}
